import * as React from 'react'
import { cn } from '@/lib/utils'

export interface InputProps extends React.ComponentPropsWithRef<'input'> {
  variant?: '' | 'small'
}

const Input = ({ ref, className, type, variant, ...props }: InputProps) => (
  <input
    type={type}
    className={cn(
      `ui-flex ui-h-14 ui-w-full ui-rounded-md ui-border ui-border-input ui-border-gray-200 ui-bg-background ui-p-4 ui-text-sm ui-ring-offset-background file:ui-border-0 file:ui-bg-transparent file:ui-text-sm file:ui-font-medium placeholder:ui-text-muted-foreground focus-visible:ui-outline-none focus-visible:ui-ring-1 focus-visible:ui-ring-ring focus-visible:ui-ring-offset-1 disabled:ui-cursor-not-allowed disabled:ui-opacity-50`,
      variant === 'small' && `ui-text-xs h-10 p-2`,
      className
    )}
    ref={ref}
    {...props}
  />
)
Input.displayName = `Input`

export { Input }
